import { FooterProps } from './FullFooter.type';
import styles from './simpleFooter.module.scss';
import {
    AppDownloadButtons,
    type DownloadButtonProps,
} from '@/ui-components/molecules/AppDownloadButtons/AppDownloadButtons';
import { LinkSet } from '@/ui-components/molecules/LinkSet/LinkSet';
import { SocialMediaIconLinks } from '@/ui-components/molecules/SocialMediaIconLinks/SocialMediaIconLinks';

export function SimpleFooter({ primaryLinks, appleStore, playStore, socialMediaItems }: FooterProps) {
    const content = primaryLinks.map(({ headline, footerLinkItems }, index) => {
        return <LinkSet key={index} links={footerLinkItems} heading={headline} variant="small" isdarkTheme={true} />;
    });

    const downloadButtons: DownloadButtonProps[] = [
        {
            badgeSrc: appleStore.badgeSrc,
            storeLink: appleStore.storeLink,
            type: 'appleStore',
        },
        {
            badgeSrc: playStore.badgeSrc,
            storeLink: playStore.storeLink,
            type: 'playStore',
        },
    ];

    return (
        <div className={styles.primaryLinksWrapper}>
            {content}
            <div className={styles.mobileStoreBadgesWrapper}>
                <AppDownloadButtons items={downloadButtons} />
            </div>
            {socialMediaItems && (
                <div className={styles.socialMediaIcons}>
                    <SocialMediaIconLinks items={socialMediaItems} isdarkTheme={true} />
                </div>
            )}
        </div>
    );
}
